import React from "react";
import propTypes from "prop-types";
import { H3, Paragraph } from "BaseComponents/Text";
import {
  HitImageWrapper,
  HitTextWrapper,
  HitMetaDataWrapper,
  HitCategory,
  HitWithCategoryWrapper,
} from "./StyledSearch";
import LazyBackgroundImage from "../../../framework/lazy/LazyBackgroundImage";
import { getResponsiveImage } from "Helpers/ImageHelper";
import { GetCategoryColor } from "Helpers/ColorHelper";

export const SearchHitWithCategory = ({
  Heading,
  Url,
  DocumentType: Category,
  Description,
  ResponsiveImage,
  Category: newsCategory,
  showPriority,
  flex = false,
  first,
  CategoryColor,
}) => {
  let Image = getResponsiveImage(ResponsiveImage);
  let beforeColor = CategoryColor
    ? `#${CategoryColor}`
    : GetCategoryColor(newsCategory);
  return (
    <HitWithCategoryWrapper href={Url} flex={flex} isFirst={first}>
      <HitImageWrapper flex={flex} isFirst={first}>
        {Image && (
          <LazyBackgroundImage
            useFocalPoint={true}
            source={Image}
            height={showPriority ? "350px" : "100%"}
          />
        )}
      </HitImageWrapper>
      <HitTextWrapper flex={flex} isFirst={first}>
        <HitMetaDataWrapper>
          <HitCategory>{Category}</HitCategory>
          {newsCategory && (
            <HitCategory beforeColor={beforeColor}>{newsCategory}</HitCategory>
          )}
        </HitMetaDataWrapper>
        <H3 size="h3" margin="1rem 0 0 0">
          <span>{Heading}</span>
        </H3>
        <Paragraph margin="1rem 0">{Description}</Paragraph>
      </HitTextWrapper>
    </HitWithCategoryWrapper>
  );
};

SearchHitWithCategory.propTypes = {
  Heading: propTypes.string,
  Url: propTypes.string,
  Category: propTypes.string,
  Description: propTypes.string,
  Image: propTypes.string,
  CategoryColor: propTypes.string,
};
